import React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LoginIcon from "@mui/icons-material/Login";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import {useNavigate} from "react-router";
import {FirebaseStateContext} from "../firebase/firebaseContext";

export const UnauthorizedAccess = ({
    title = "Adgang begrenset",
    message = "Du må være innlogget som administrator for å få tilgang til denne siden.",
    requiredRole = "administrator",
    user,
}) => {
    const navigate = useNavigate();
    const firebaseState = React.useContext(FirebaseStateContext);
    const currentUser = user || firebaseState?.auth?.currentUser || null;

    return (
        <Container maxWidth="sm" sx={{py: {xs: 6, md: 10}}}>
            <Paper
                elevation={0}
                sx={{
                    p: {xs: 3, sm: 5},
                    textAlign: "center",
                    borderRadius: 4,
                    border: "1px solid rgba(40, 82, 56, 0.12)",
                    bgcolor: "background.paper",
                    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.04)",
                }}
            >
                <Box
                    sx={{
                        width: 64,
                        height: 64,
                        borderRadius: "50%",
                        bgcolor: "rgba(217, 119, 6, 0.12)",
                        color: "#B45309",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mx: "auto",
                        mb: 2.5,
                    }}
                >
                    <LockOutlinedIcon sx={{fontSize: 34}} />
                </Box>

                <Typography
                    variant="h5"
                    component="h1"
                    sx={{
                        fontWeight: 800,
                        color: "text.primary",
                        letterSpacing: "-0.01em",
                        mb: 1.5,
                    }}
                >
                    {title}
                </Typography>

                <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{lineHeight: 1.6, mb: 3}}
                >
                    {currentUser
                        ? `Du er logget inn som ${currentUser.email || "bruker"}, men har ikke ${requiredRole}-rettigheter til dette området.`
                        : message}
                </Typography>

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: {xs: "column", sm: "row"},
                        gap: 1.5,
                        justifyContent: "center",
                    }}
                >
                    {!currentUser ? (
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            startIcon={<LoginIcon />}
                            onClick={() => navigate("/login")}
                            sx={{borderRadius: 2.5, fontWeight: 700, px: 3}}
                        >
                            Logg inn
                        </Button>
                    ) : (
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            startIcon={<AccountCircleIcon />}
                            onClick={() => navigate("/me")}
                            sx={{borderRadius: 2.5, fontWeight: 700, px: 3}}
                        >
                            Tilbake til Min side
                        </Button>
                    )}

                    <Button
                        variant="outlined"
                        color="inherit"
                        size="large"
                        startIcon={<ArrowBackIcon />}
                        onClick={() => navigate("/")}
                        sx={{borderRadius: 2.5, fontWeight: 600, color: "text.secondary", px: 2.5}}
                    >
                        Til forsiden
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
};
